import RouterView from '@/page/main/DefaultRouterView'
import List from '@/page/seal/list'
import UseList from '@/page/seal/uselist'
import OperateList from '@/page/seal/operatelist'

import Create from '@/page/seal/create'
import Create2 from '@/page/seal/create2'


import ReadMeList from '@/page/seal/readme'
import ReadMeSave from '@/page/seal/readmeCreate'

export default {
  path: '/Seal',
  component: RouterView,
  children: [{
      path: 'Create',
      meta: {
        type: ['seal', 'sealuselist'],
        title: '使用/外带印章'
      },
      component: Create
    }, {
      path: 'Create2',
      meta: {
        type: ['seal', 'sealoperatelist'],
        title: '刻制/销毁印章'
      },
      component: Create2
    },
    {
      path: 'List',
      meta: {
        type: ['seal', 'seallist'],
        title: '印章列表'
      },
      component: List
    },
    {
      path: 'Use/List',
      meta: {
        type: ['seal', 'sealuselist'],
        title: '使用/外带印章申请列表'
      },
      component: UseList
    },
    {
      path: 'Operate/List',
      meta: {
        type: ['seal', 'sealoperatelist'],
        title: '刻制/销毁印章申请列表'
      },
      component: OperateList
    },
    {
      path: 'ReadMe/List',
      meta: {
        type: ['seal', 'sealreadmelist'],
        title: '印章审批说明列表'
      },
      component: ReadMeList
    },
    {
      path: 'ReadMe/Save',
      meta: {
        type: ['seal', 'readMeSave'],
        title: '新建/编辑印章审批说明'
      },
      component: ReadMeSave
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/seal.js